import type { Theme } from 'hephaestus/core';

type SnapshotToneColors = {
  /** Card surface background — uses the lighter `*Variant` token for the tinted look. */
  background: string;
  /** Strong tone colour used for the primary value. */
  valueColor: string;
};

/**
 * Map a snapshot tone to theme color tokens used for the card background and
 * value text. The card is rendered as a fully tinted surface — no border accents.
 * Mirrors the styling pattern established in
 * `ovComponents/5-page/reconciliationV2/accountSnapshot.tsx`, which uses
 * `theme.color.<tone>Variant` for full-cell tinted backgrounds.
 */
export const getSnapshotToneColors = (
  tone: 'positive' | 'negative' | 'warning' | 'primary' | 'neutral',
  theme: Theme,
): SnapshotToneColors => {
  switch (tone) {
    case 'positive':
      return {
        background: theme.color.positiveVariant,
        valueColor: theme.color.positive,
      };
    case 'negative':
      return {
        background: theme.color.negativeVariant,
        valueColor: theme.color.negative,
      };
    case 'warning':
      return {
        background: theme.color.warningVariant,
        valueColor: theme.color.warning,
      };
    case 'primary':
      return {
        background: theme.color.primaryVariant,
        valueColor: theme.color.primary,
      };
    default:
      return {
        background: theme.color.surface,
        valueColor: theme.color.onSurface,
      };
  }
};
